import {
  Boolean,
  Date,
  DefaultSearchTerms,
  DisplayOrder,
  Hidden,
  Number,
  Options,
  ReadOnly,
  Required,
  String,
  TableDisplayed,
  TableDisplayedDefault,
  TableIdentifier
} from "projects/nter-ui-kit/src/lib/webkit/components/crud-item/crud-item-decorator";

import {
  PlatformFeature
} from "projects/admin-portal/src/app/features/rbac/config/config-features/platform-feature.model";

// import {PlatformFeature} from "@features/rbac-config/config-features/platform-feature.model";

@DefaultSearchTerms(['active:true'])
export class PlatformRole {
  @Number('ID')
  @ReadOnly
  @DisplayOrder(1)
  @TableIdentifier
  id?: number;

  @String('Code')
  @Required
  @DisplayOrder(2)
  @TableDisplayedDefault
  code?: string;

  @Required
  @String('Display name')
  @DisplayOrder(3)
  @TableDisplayedDefault
  name?: string;

  // @Required
  @String('Description')
  @DisplayOrder(4)
  description?: string;

  @Required
  @String('Module Id')
  @DisplayOrder(5)
  @TableDisplayedDefault
  moduleId?: string;

  @Required
  @String('Principle Type')
  @DisplayOrder(6)
  @Options([
    {RETAILER: 'RETAILER'},
    {CLIENT_SYSTEM: 'CLIENT_SYSTEM'},
    {SYSTEM_RBAC: 'SYSTEM-RBAC'},
    {LOCATION: 'LOCATION'},
    {OFFERING: 'OFFERING'},
    {USER: 'USER'},
    {DISTRICT: 'DISTRICT'},
    {STORAGE: 'STORAGE'},
    {KIOSK: 'KIOSK'},
    {SPACES: 'SPACES'},
    {GENERAL_LEASING: 'GENERAL_LEASING'},
    {POP_UPS: 'POP_UPS'},
    {DIGITAL_ADVERTISING: 'DIGITAL_ADVERTISING'},
    {MARKETS: 'MARKETS'},
    {EXHIBITIONS: 'EXHIBITIONS'},
    {SYSTEM: 'SYSTEM'}
  ])
  @TableDisplayedDefault
  principleType?: string;

  @Required
  @String('System Code')
  @DisplayOrder(7)
  @Options([{CONSOLE: 'Landlord portal'}, {PORTAL: 'Tenant portal'}])
  @TableDisplayedDefault
  platformSystemCode?: string;

  @Boolean('Active')
  @DisplayOrder(7)
  @TableDisplayedDefault
  active?: boolean = true;

  @Number('')
  @Hidden
  serialVersionUID?: number;

  @Date('Create Date', 'yyyy-MM-dd')
  @Hidden
  @TableDisplayed
  createDate?: string;

  @Number('Create User')
  @Hidden
  @TableDisplayed
  createUserId?: number;

  @Date('Update Date', 'yyyy-MM-dd')
  @Hidden
  @TableDisplayed
  updateDate?: string;

  @Number('Update User')
  @Hidden
  @TableDisplayed
  updateUserId?: number;

  @Hidden
  features?: PlatformFeature[];

  constructor(obj: any = {}) {
    obj = obj || {};
    this.id = obj.id ? obj.id : null;
    this.code = obj.code ? obj.code : null;
    this.name = obj.name ? obj.name : null;
    this.description = obj.description ? obj.description : null;
    this.moduleId = obj.moduleId ? obj.moduleId : null;
    this.principleType = obj.principleType ? obj.principleType : null;
    this.platformSystemCode = obj.platformSystemCode ? obj.platformSystemCode : null;
    this.serialVersionUID = obj.serialVersionUID ? obj.serialVersionUID : null;
    this.active = obj.active ? obj.active : null;
    this.createDate = obj.createDate ? obj.createDate : null;
    this.createUserId = obj.createUserId ? obj.createUserId : null;
    this.updateDate = obj.updateDate ? obj.updateDate : null;
    this.updateUserId = obj.updateUserId ? obj.updateUserId : null;
    this.features = obj.features ? obj.features : [];
  }
}
